import { useEffect } from "react";
import { Link } from "react-router-dom";

/**
 * Institut Impact Élite — Landing Plateforme Formation (POC V3 Hybride Éditorial)
 */
export default function PlateformeLanding() {
  useEffect(() => {
    document.title = "Institut Impact Élite — Plateforme de Formation";
    // Inject Google Fonts dynamiquement (Playfair Display + Inter)
    const linkPreconn = document.createElement("link");
    linkPreconn.rel = "preconnect";
    linkPreconn.href = "https://fonts.googleapis.com";
    document.head.appendChild(linkPreconn);
    const linkFonts = document.createElement("link");
    linkFonts.rel = "stylesheet";
    linkFonts.href =
      "https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;700;900&family=Inter:wght@300;400;500;700&display=swap";
    document.head.appendChild(linkFonts);
    return () => {
      document.head.removeChild(linkPreconn);
      document.head.removeChild(linkFonts);
    };
  }, []);

  const baseStyle = {
    fontFamily: "Inter, system-ui, sans-serif",
    background: "#0d0d0d",
    color: "#f5f5f5",
    minHeight: "100vh",
  };

  return (
    <div style={baseStyle} data-testid="plateforme-landing">
      <style>{`
        .editorial { font-family: 'Playfair Display', serif; }
        .label { letter-spacing: 0.4em; font-size: 11px; }
        .frame { border: 1px solid rgba(201, 169, 97, 0.25); }
        .divider-gold { background: linear-gradient(90deg, transparent, #C9A961 30%, #C9A961 70%, transparent); height: 1px; }
        .gold { color: #C9A961; }
        .red-c { color: #C8102E; }
        .bg-red-c { background: #C8102E; }
        .bg-gold { background: #C9A961; }
        .btn-primary { background: #C8102E; color: #fff; transition: 0.3s; }
        .btn-primary:hover { background: #fff; color: #C8102E; }
        .btn-secondary { color: #C9A961; border: 1px solid #C9A961; transition: 0.3s; background: transparent; }
        .btn-secondary:hover { background: #C9A961; color: #0d0d0d; }
        .pf-link { transition: color 0.2s; }
        .pf-link:hover { color: #C9A961; }
        .discipline-card { transition: background 0.3s; cursor: pointer; }
        .discipline-card:hover { background: #161616; }
        .discipline-card:hover .arrow-link { transform: translateX(8px); }
        .arrow-link { transition: transform 0.3s; display: inline-block; }
      `}</style>

      {/* === NAV === */}
      <nav
        className="px-10 py-6 flex items-center justify-between sticky top-0 z-50 backdrop-blur-md"
        style={{ background: "rgba(0,0,0,0.8)", borderBottom: "1px solid rgba(255,255,255,0.05)" }}
        data-testid="plateforme-nav"
      >
        <Link to="/plateforme" className="flex items-center gap-4" data-testid="nav-logo">
          <div className="relative">
            <div className="w-12 h-12 bg-red-c flex items-center justify-center">
              <span className="editorial text-white text-2xl font-black">I</span>
            </div>
            <div className="absolute -bottom-1 -right-1 w-3 h-3 bg-gold"></div>
          </div>
          <div>
            <div className="label gold">— INSTITUT —</div>
            <div className="editorial text-2xl font-bold leading-none mt-0.5">Impact Élite</div>
          </div>
        </Link>
        <div className="hidden md:flex gap-10 text-sm">
          <a href="#disciplines" className="pf-link" data-testid="nav-disciplines">Disciplines</a>
          <a href="#methode" className="pf-link" data-testid="nav-methode">Méthode</a>
          <a href="#progression" className="pf-link" data-testid="nav-progression">Progression</a>
                    <Link to="/plateforme/fondateur" className="pf-link" data-testid="nav-fondateur">Le Fondateur</Link>
          <a href="#tarifs" className="pf-link" data-testid="nav-tarifs">Tarifs</a>
        </div>
        <Link to="/plateforme/login" className="btn-secondary px-6 py-2 text-xs tracking-[0.3em]" data-testid="nav-login">CONNEXION</Link>
      </nav>

      {/* === HERO ÉDITORIAL === */}
      <section className="grid md:grid-cols-12" style={{ minHeight: "88vh" }} data-testid="hero-section">
        <div className="md:col-span-7 px-10 py-20 flex flex-col justify-center relative">
          <div className="label red-c mb-8">VOLUME 01 · CHAPITRE 01</div>
          <h1 className="editorial font-black text-5xl md:text-8xl leading-[0.9] mb-10" data-testid="hero-title">
            L'art<br />du combat,<br />
            <span className="italic gold">enseigné</span><br />
            <span className="text-white">avec rigueur.</span>
          </h1>
          <div className="divider-gold w-40 mb-8"></div>
          <p className="editorial italic text-xl md:text-2xl text-white/80 max-w-xl mb-12 leading-relaxed">
            « Une méthode. Un cadre. Une mentalité. Bâtie à Val-d'Or, transmise à ceux qui veulent vraiment évoluer. »
          </p>
          <div className="flex flex-wrap gap-4">
            <a href="#tarifs" className="btn-primary px-8 py-4 font-bold tracking-[0.2em] text-xs" data-testid="hero-cta-primary">
              DÉBUTER LE PARCOURS →
            </a>
            <a href="#fondateur" className="btn-secondary px-8 py-4 font-bold tracking-[0.2em] text-xs" data-testid="hero-cta-secondary">
              DÉCOUVRIR LE FONDATEUR
            </a>
          </div>
          <div className="mt-16 grid grid-cols-3 gap-8 max-w-lg">
            <div data-testid="hero-stat-years"><div className="editorial text-4xl font-bold gold">25+</div><div className="label text-white/50 mt-1">ANS</div></div>
            <div data-testid="hero-stat-disciplines"><div className="editorial text-4xl font-bold gold">04</div><div className="label text-white/50 mt-1">DISCIPLINES</div></div>
            <div data-testid="hero-stat-reach"><div className="editorial text-4xl font-bold gold">QC→∞</div><div className="label text-white/50 mt-1">PORTÉE</div></div>
          </div>
        </div>
        <div className="md:col-span-5 bg-red-c relative flex flex-col justify-center px-10 py-20" id="fondateur">
          <div className="absolute top-10 right-10 label text-white/70">N°&nbsp;001</div>
          <div className="absolute bottom-10 right-10 label text-white/70">VAL-D'OR · QUÉBEC</div>
          <div className="frame p-10" style={{ borderColor: "rgba(255,255,255,0.3)", background: "rgba(0,0,0,0.2)", backdropFilter: "blur(8px)" }} data-testid="hero-founder-card">
            <div className="label text-white/80 mb-4">— LE FONDATEUR —</div>
            <div className="editorial text-3xl font-bold mb-2 text-white">Ralph-David</div>
            <div className="editorial text-3xl font-bold mb-6 text-white">Jean-Pierre</div>
            <div className="text-sm text-white/85 leading-relaxed mb-6">
              Coach. Combattant. Producteur du Gala Gladiateurs du Nord. Bâtisseur d'un circuit où la prochaine génération peut s'élever.
            </div>
            <div className="divider-gold mb-4 opacity-60"></div>
            <div className="label text-white/70">25 ANS DE TERRAIN — INSTITUT IMPACT ÉLITE</div>
          </div>
        </div>
      </section>

      {/* === STATEMENT MÉTHODE === */}
      <section className="py-20 px-10" style={{ background: "#161616" }} id="methode" data-testid="methode-section">
        <div className="max-w-4xl mx-auto text-center">
          <div className="label gold mb-6">— LA MÉTHODE —</div>
          <p className="editorial text-2xl md:text-4xl italic leading-relaxed text-white/90">
            « Mon rôle n'est pas seulement d'enseigner des mouvements.{" "}
            <span className="gold not-italic font-bold">Mon rôle est de transmettre une méthode</span>, une mentalité, un cadre et une force intérieure qui peuvent aider une personne à évoluer autant dans sa pratique que dans sa vie. »
          </p>
          <div className="divider-gold w-32 mx-auto my-10"></div>
          <div className="label text-white/40">— RDJP, INSTITUT IMPACT ÉLITE —</div>
        </div>
      </section>

      {/* === DISCIPLINES === */}
      <section className="px-10 py-24" id="disciplines" data-testid="disciplines-section">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-12 mb-16 gap-8 items-end">
            <div className="md:col-span-7">
              <div className="label red-c mb-4">CHAPITRE 02 — LES DISCIPLINES</div>
              <h2 className="editorial font-black text-4xl md:text-6xl leading-tight">
                Trois <span className="gold italic">arts</span><br />au service d'<span className="italic">un</span> combattant.
              </h2>
            </div>
            <div className="md:col-span-5 text-white/60 text-sm leading-relaxed">
              Chaque discipline est une voie d'accès à une dimension du combat. Ensemble, elles forment un parcours complet, mesuré, mesurable.
            </div>
          </div>
          <div className="grid md:grid-cols-2 gap-px" style={{ background: "rgba(201,169,97,0.2)" }}>
            {[
              { n: "01", slug: "kickboxing", lbl: "PILIER", title: "Kickboxing / Muay Thaï", desc: "Frappe debout et art des huit membres réunis. Distance, pression, coudes, genoux, clinch. Le socle complet du combattant moderne." },
              { n: "02", slug: "jiu-jitsu-japonais", lbl: "TRADITION", title: "Jiu-Jitsu Can Ryu", desc: "Tradition, contrôle, projections. Lignage et discipline ancestrale. La voie du contrôle stratégique." },
              { n: "03", slug: "jiu-jitsu-bresilien", lbl: "LABORATOIRE", title: "Jiu-Jitsu Brésilien", desc: "Le sol comme laboratoire. Levier, patience, soumission. L'art de la résolution de problèmes." },
            ].map((d) => (
              <Link key={d.n} to={`/plateforme/disciplines/${d.slug}`} className="discipline-card p-12 block" style={{ background: "#0d0d0d" }} data-testid={`discipline-card-${d.n}`}>
                <div className="flex items-baseline justify-between mb-6">
                  <div className="editorial font-black text-7xl gold" style={{ opacity: 0.8 }}>{d.n}</div>
                  <div className="label text-white/40">{d.lbl}</div>
                </div>
                <div className="editorial font-bold text-3xl mb-3">{d.title}</div>
                <div className="text-sm text-white/70 leading-relaxed mb-6">{d.desc}</div>
                <div className="label gold arrow-link">EXPLORER →</div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* === PROGRESSION === */}
      <section className="px-10 py-24" style={{ background: "#161616" }} id="progression" data-testid="progression-section">
        <div className="max-w-7xl mx-auto grid md:grid-cols-12 gap-16 items-center">
          <div className="md:col-span-5">
            <div className="label red-c mb-4">CHAPITRE 03 — PROGRESSION</div>
            <h2 className="editorial font-black text-4xl md:text-6xl leading-tight mb-8">
              Mesurer.<br /><span className="italic gold">Valider.</span><br />S'élever.
            </h2>
            <p className="text-white/70 leading-relaxed mb-8">
              Chaque technique notée. Chaque cycle validé. Chaque check-in compté. Le progrès n'est plus flou — il est visible, stimulant, engageant.
            </p>
            <div className="space-y-3 text-sm text-white/80">
              <div className="flex gap-3"><span className="gold">◆</span> Pourcentage de maîtrise par technique</div>
              <div className="flex gap-3"><span className="gold">◆</span> Validations par paliers de niveau</div>
              <div className="flex gap-3"><span className="gold">◆</span> Constance, défis et check-ins réguliers</div>
              <div className="flex gap-3"><span className="gold">◆</span> Repères pour structurer l'engagement</div>
            </div>
          </div>
          <div className="md:col-span-7 frame p-10" style={{ background: "#0d0d0d" }} data-testid="progression-card">
            <div className="flex justify-between items-start mb-8 pb-6" style={{ borderBottom: "1px solid rgba(201,169,97,0.2)" }}>
              <div>
                <div className="label gold mb-1">CARNET DE PROGRESSION</div>
                <div className="editorial font-bold text-3xl">Kickboxing — Niveau II</div>
                <div className="text-xs text-white/50 mt-2">Cycle 07 · Athlète #0024</div>
              </div>
              <div className="bg-red-c px-4 py-2">
                <div className="editorial font-black text-3xl text-white">56%</div>
                <div className="text-[10px] text-white/80 tracking-widest text-center">PALIER</div>
              </div>
            </div>
            <div className="space-y-6">
              {[
                { name: "Jab + croix · combinaisons", value: 82 },
                { name: "Low kick · timing", value: 64 },
                { name: "Esquive + contre", value: 48 },
                { name: "Pression · gestion distance", value: 31 },
              ].map((t) => (
                <div key={t.name} data-testid={`progress-${t.name.replace(/[^a-z]/gi, "-").toLowerCase()}`}>
                  <div className="flex justify-between mb-2">
                    <span className="text-sm">{t.name}</span>
                    <span className="editorial font-bold gold">{t.value}%</span>
                  </div>
                  <div className="h-1" style={{ background: "rgba(255,255,255,0.05)" }}>
                    <div className="h-1 bg-gold" style={{ width: `${t.value}%` }}></div>
                  </div>
                </div>
              ))}
            </div>
            <div className="divider-gold mt-8 mb-4 opacity-50"></div>
            <div className="flex justify-between text-xs">
              <span className="label text-white/50">PROCHAIN PALIER</span>
              <span className="label red-c">SPARRING · J-21</span>
            </div>
          </div>
        </div>
      </section>

      {/* === TARIFS === */}
      <section className="px-10 py-24" id="tarifs" data-testid="tarifs-section">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <div className="label red-c mb-4">CHAPITRE 04 — ENGAGEMENT</div>
            <h2 className="editorial font-black text-4xl md:text-6xl mb-4">
              Trois <span className="italic gold">parcours</span>. Une seule exigence.
            </h2>
            <p className="text-white/60 max-w-2xl mx-auto">
              Aucune dilution. Aucune fausse promesse. Que de la transmission, à la mesure de votre engagement.
            </p>
          </div>
          <div className="grid md:grid-cols-3 gap-px" style={{ background: "rgba(201,169,97,0.2)" }}>
            {/* PCO — Premier Cycle Ouvert */}
            <div className="p-10" style={{ background: "#0d0d0d" }} data-testid="tarif-pco">
              <div className="label gold mb-2">— PCO —</div>
              <div className="editorial font-bold text-3xl mb-2">Premier Cycle Ouvert</div>
              <div className="editorial font-black text-6xl mb-1">150 <span className="text-2xl text-white/40">$ / 12 sem.</span></div>
              <div className="text-xs text-white/50 mb-8">— 3 fois par semaine · accès illimité —</div>
              <ul className="text-sm space-y-3 text-white/70 mb-10">
                <li className="flex gap-2"><span className="gold">◆</span> Accès 1 discipline</li>
                <li className="flex gap-2"><span className="gold">◆</span> Bibliothèque techniques fondamentales</li>
                <li className="flex gap-2"><span className="gold">◆</span> Cycles 4, 8, 12, 24 ou 52 semaines</li>
                <li className="flex gap-2"><span className="gold">◆</span> Idéal pour démarrer</li>
              </ul>
              <button className="btn-secondary w-full py-3 text-xs tracking-[0.2em]" data-testid="cta-pco">CHOISIR PCO</button>
              <div className="text-[10px] text-white/40 mt-3 tracking-widest">ALIGNÉ TARIFS DOJO ZENPLANNER</div>
            </div>
            {/* PCN — Premier Cycle Normal */}
            <div className="p-10 relative" style={{ background: "#161616", boxShadow: "inset 0 0 0 2px #C8102E" }} data-testid="tarif-pcn">
              <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-red-c text-white text-xs px-4 py-1 tracking-widest">★ RECOMMANDÉ</div>
              <div className="label gold mb-2">— PCN —</div>
              <div className="editorial font-bold text-3xl mb-2">Premier Cycle Normal</div>
              <div className="editorial font-black text-6xl mb-1">171 <span className="text-2xl text-white/40">$ / 12 sem.</span></div>
              <div className="text-xs text-white/50 mb-8">— 3 fois par semaine · accès illimité —</div>
              <ul className="text-sm space-y-3 text-white/70 mb-10">
                <li className="flex gap-2"><span className="gold">◆</span> 2 disciplines au choix</li>
                <li className="flex gap-2"><span className="gold">◆</span> Bibliothèque complète</li>
                <li className="flex gap-2"><span className="gold">◆</span> Suivi progression % par technique</li>
                <li className="flex gap-2"><span className="gold">◆</span> Check-ins illimités</li>
                <li className="flex gap-2"><span className="gold">◆</span> Communauté privée</li>
              </ul>
              <button className="btn-primary w-full py-3 text-xs tracking-[0.2em] font-bold" data-testid="cta-pcn">CHOISIR PCN</button>
              <div className="text-[10px] text-white/40 mt-3 tracking-widest">PROGRESSION STRUCTURÉE</div>
            </div>
            {/* MASTER CLUB / MASTERCLASS */}
            <div className="p-10" style={{ background: "#0d0d0d" }} data-testid="tarif-master">
              <div className="label gold mb-2">— MASTER CLUB —</div>
              <div className="editorial font-bold text-3xl mb-2">Masterclass</div>
              <div className="editorial font-black text-6xl mb-1">193 <span className="text-2xl text-white/40">$ / 12 sem.</span></div>
              <div className="text-xs text-white/50 mb-8">— 3 fois par semaine · niveau élite —</div>
              <ul className="text-sm space-y-3 text-white/70 mb-10">
                <li className="flex gap-2"><span className="gold">◆</span> 4 disciplines complètes</li>
                <li className="flex gap-2"><span className="gold">◆</span> Coaching direct fondateur</li>
                <li className="flex gap-2"><span className="gold">◆</span> Validations privées</li>
                <li className="flex gap-2"><span className="gold">◆</span> Accès anticipé événements</li>
                <li className="flex gap-2"><span className="gold">◆</span> Mentorat continu</li>
              </ul>
              <button className="btn-secondary w-full py-3 text-xs tracking-[0.2em]" data-testid="cta-master">CHOISIR MASTER</button>
              <div className="text-[10px] text-white/40 mt-3 tracking-widest">CEINTURES BRUNE → NOIRE</div>
            </div>
          </div>
          <div className="text-center mt-10 text-xs text-white/40 tracking-widest max-w-3xl mx-auto leading-relaxed">
            TARIFS ALIGNÉS AVEC LE DOJO PHYSIQUE (ZENPLANNER) · CYCLES DISPONIBLES : 4, 8, 12, 24, 52 SEMAINES · DROP-IN 30$ · COURS D'ESSAI (19,98 $)
          </div>
        </div>
      </section>

      {/* === FOOTER === */}
      <footer className="px-10 py-16" style={{ borderTop: "1px solid rgba(201,169,97,0.2)" }} data-testid="footer">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-12 gap-10 items-start mb-12">
            <div className="md:col-span-5">
              <div className="editorial font-black text-3xl mb-2">Institut Impact Élite</div>
              <div className="text-sm text-white/60 leading-relaxed max-w-md">
                Une plateforme de transmission. Une méthode. Une vision. Bâtie à Val-d'Or, transmise au monde.
              </div>
            </div>
            <div className="md:col-span-3">
              <div className="label gold mb-4">— PARCOURS</div>
              <ul className="space-y-2 text-sm text-white/70">
                <li>Kickboxing / Muay Thaï</li>
                <li>Jiu-Jitsu Can Ryu</li>
                <li>Jiu-Jitsu Brésilien</li>
              </ul>
            </div>
            <div className="md:col-span-4">
              <div className="label gold mb-4">— FONDATION</div>
              <div className="text-sm text-white/60 leading-relaxed">
                Fondation Ralph-David Jean-Pierre<br />
                Val-d'Or, Québec, Canada<br />
                <a href="mailto:sdm.rdjp@gmail.com" className="pf-link">sdm.rdjp@gmail.com</a>
              </div>
            </div>
          </div>
          <div className="divider-gold mb-6"></div>
          <div className="text-xs text-white/40 tracking-widest text-center">
            © 2026 — INSTITUT IMPACT ÉLITE · POC PHASE 1 · TOUS DROITS RÉSERVÉS
          </div>
        </div>
      </footer>
    </div>
  );
}
